import pkg from '../../package.json';

export const environment = {
    firebase: {
        apiKey: 'AIzaSyAe8eZic-GLHd7eLAWkGlId2HXJTQ_Om_I',
        authDomain: 'wasteland-warfare.firebaseapp.com',
        databaseURL: 'https://wasteland-warfare.firebaseio.com',
        projectId: 'wasteland-warfare',
        storageBucket: 'wasteland-warfare.appspot.com',
        messagingSenderId: '280958953804',
        appId: '1:280958953804:web:7d6f97b0fb20b3380607e9'
    },
    production: true,
    apiBaseUrl: '/api',
    appVersion: 'v' + pkg.version
};
